module.exports = __webpack_public_path__ + "static/media/noun_Wine_9305.bbc2d26c.svg";